<template>
  <b-card header="Nueva Orden de Trabajo">
    <Form :incident_id="id" />
  </b-card>
</template>

<script>
import Form from "./Form";
export default {
  components: { Form },
  data() {
    return {
      id: this.$route.params.id
    };
  }
};
</script>
